import React from 'react';
import { Button } from '../ButtonElements';
import logo from '../../assets/Ralph_logo.png';
import { InfoContainer, InfoWrapper, InfoRow, Column1, Column2, TextWrapper, TopLine, Heading, Subtitle, BtnWrap, Img, ImgWrap } from './InfoElements';

const InfoSection2 = ({ lightBg, id, imgStart, topLine, lightText, headline, headline1, headline2, darkText, description, description1, description2, buttonLabel, img, alt, primary, dark, dark2 }) => {
  return (
    <>
      <InfoContainer lightBg={lightBg} id={id}>
        <InfoWrapper>
          <InfoRow imgStart={imgStart}>
            <Column1>
                <TextWrapper>
                <Heading lightText={lightText}>{headline2}</Heading>
                <Subtitle darkText={darkText}>{description2}</Subtitle>
                <Subtitle darkText={darkText}>
                  <ul>
                    <li>Professionalism and Integrity</li>
                    <li>Respect for the rule of law</li>
                    <li>Team work</li>
                    <li>Confidentiality and honesty</li>
                  </ul>
                </Subtitle>
              </TextWrapper>
                <BtnWrap>
                  <Button to='home' smooth={true} duration={500} spy={true} exact='true' offset={-80} primary={primary ? 1 : 0} dark={dark ? 1 : 0} dark2={dark2 ? 1 : 0}>{buttonLabel}</Button>
                </BtnWrap>

            </Column1>

            <Column2>
              <TextWrapper>
                <TopLine>{topLine}</TopLine>
                <Heading lightText={lightText}>{headline}</Heading>
                <Subtitle darkText={darkText}>{description}</Subtitle>
                <Heading lightText={lightText} style={{ paddingTop: "20px" }}>{headline1}</Heading>
                <Subtitle darkText={darkText}>{description1}</Subtitle>
              </TextWrapper>

            </Column2>


          </InfoRow>
        </InfoWrapper>
      </InfoContainer>
    </>
  );
};

export default InfoSection2;
